<div class="link-button-container">
  <mat-icon
    *ngIf="showIcon"
    class="link-button-icon"
    fontSet="material-symbols-outlined"
    >expand_circle_down
  </mat-icon>
  <button
    (click)="onClick.emit()"
    [ngClass]="_classes"
    [type]="type"
    [attr.aria-label]="ariaLabel || null"
  >
    <ng-content />
  </button>
</div>
